import gql from 'graphql-tag'

import { AppAcceptDisclaimerMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation AppAcceptDisclaimer($signature: String!) {
      rdvAcceptDisclaimer(signature: $signature) {
        id
        disclaimer_accepted
      }
    }
  `,
  transformer: (response: AppAcceptDisclaimerMutation) => {
    return response.rdvAcceptDisclaimer
  },
}
